/* eslint-disable react/jsx-filename-extension */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable import/prefer-default-export */
import React from 'react'
import { CheckIcon } from './CheckIcon'

import s from './DropdownRow.module.css'

/**
 * Individual row component for dropdown options
 */
export const DropdownRow = React.memo(({ data, index, style }) => {
  const { filteredOptions, selectedValues, toggleValue } = data
  const option = filteredOptions[index]
  const isChecked = selectedValues?.includes(option.value)

  return (
    <div
      style={style}
      className={s.dropdownItem}
      onClick={(e) => {
        e.stopPropagation()
        toggleValue(option.value)
      }}
    >
      <div className={s.dropdownCheck}>{isChecked && <CheckIcon />}</div>

      <div className={s.dropdownContent}>{option.content || option.label}</div>
    </div>
  )
})
